import React, { Component } from "react";
import SegmentTable from "../Table";

import "../segmentlist.css";
import { getUrlParameterByName } from "../../../../utils/utility";

class Archive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortOrder: "desc",
      sortName: "Date Archived",
      sortColumn: "archivedTime",
      tableHeadData: [
        "Select",
        "ARCHIVE DATE",
        "AUDIENCE SEGMENTS",
        "COUNT",
        "CLIENT",
        "DATE CREATED",
      ],
      pageNumber: 1,
    };
  }
  componentDidMount() {
    const cid = getUrlParameterByName("cid");
    if (cid) {
      this.props.selectClient(parseInt(cid, 10));
      this.props.getSegmentList({
        clientId: parseInt(cid, 10),
        pageNumber: 1,
        sortColumn: "archivedTime",
        pageSize: 10,
        status: "Archived",
        order: "desc",
      });
    } else {
      this.props.getSegmentList({
        clientId: this.props.selected_client,
        pageNumber: 1,
        sortColumn: "archivedTime",
        pageSize: 10,
        status: "Archived",
        order: "desc",
      });
      this.props.history.push(
        "/segments/list/archive?cid=" + this.props.selected_client,
      );
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.selected_client === "0") {
      this.setState({
        tableHeadData: [
          "Select",
          "ARCHIVE DATE",
          "AUDIENCE SEGMENTS",
          "COUNT",
          "CLIENT",
          "DATE CREATED",
        ],
      });
    } else {
      this.setState({
        tableHeadData: [
          "Select",
          "Audience Segment",
          "Date Archived",
          "Source",
          "Status",
        ],
      });
    }

    if (nextProps.selected_client !== this.props.selected_client) {
      this.props.getSegmentList({
        clientId:
          parseInt(nextProps.selected_client, 10) >= 0
            ? nextProps.selected_client
            : null,
        pageNumber: this.state.pageNumber,
        sortColumn: "archivedTime",
        pageSize: 10,
        status: "Archived",
        order: "desc",
      });
      this.props.history.push(
        "/segments/list/archive?cid=" + nextProps.selected_client,
      );
    } /*
    if (nextProps.roleId === 5) {
      window.location = "/"
    }*/
    if (nextProps.sourceType !== this.props.sourceType) {
      this.setState({
        sortColumn: "archivedTime",
        cache_sortColumn: "archivedTime",
        sortName: "Date Archived",
      });
    }
  }
  handleHeaderClick(targetText, pageIndex) {
    this.setState({
      cache_sortColumn: targetText,
    });
    let obj = {
      sortOrder:
        this.state.sortOrder === "desc" &&
        this.state.cache_sortColumn === targetText
          ? "asc"
          : "desc",
      sortName: targetText,
    };
    switch (targetText) {
      case "Date Archived":
        obj = {
          ...obj,
          sortColumn: "archivedTime",
        };
        break;
      case "Audience Segment":
        obj = {
          ...obj,
          sortColumn: "name",
        };
        break;
      case "DATE CREATED":
        obj = {
          ...obj,
          sortColumn: "createdTime",
        };
        break;
      case "CLIENT":
        obj = {
          ...obj,
          sortColumn: "clientId",
        };
        break;
      case "Status":
        obj = {
          ...obj,
          sortColumn: "status",
        };
        break;
      case "Source":
        obj = {
          ...obj,
          sortColumn: "sourcce",
        };
        break;
      default:
        return;
    }

    this.setState(obj, () => {
      this.dispatchPageAction(pageIndex);
    });
  }
  handlePageClick(page) {
    this.dispatchPageAction(page);
  }
  goNext(page) {
    this.dispatchPageAction(page);
  }
  goPrevious(page) {
    this.dispatchPageAction(page);
  }
  selectRows(page, row) {
    this.setState(
      {
        pageSize: row,
      },
      () => {
        this.dispatchPageAction(page);
      },
    );
  }
  goToPage(page) {
    if (page > this.props.segment_list_archive.pageCount) {
      return;
    } else {
      this.dispatchPageAction(page);
    }
  }
  dispatchPageAction(page, order = "") {
    this.setState({
      pageNumber: page,
    });
    this.props.getSegmentList({
      clientId:
        parseInt(this.props.selected_client, 10) >= 0
          ? this.props.selected_client
          : null,
      sortColumn: this.state.sortColumn,
      pageNumber: page,
      pageSize: this.state.pageSize,
      status: "Archived",
      order: this.state.sortOrder,
    });
  }
  nextGroup(page) {
    this.dispatchPageAction(page);
  }
  previousGroup(page) {
    this.dispatchPageAction(page);
  }
  handleCreateSegmentClick() {
    this.props.history.push("/segment/create");
  }
  handleIconClick(targetText, pageIndex) {
    let obj = {
      sortOrder: this.state.sortOrder === "desc" ? "asc" : "desc",
      sortName: targetText,
    };
    switch (targetText) {
      case "Date Archived":
        obj = {
          ...obj,
          sortColumn: "archivedTime",
        };
        break;
      case "Audience Segment":
        obj = {
          ...obj,
          sortColumn: "name",
        };
        break;
      case "DATE CREATED":
        obj = {
          ...obj,
          sortColumn: "createdTime",
        };
        break;
      case "CLIENT":
        obj = {
          ...obj,
          sortColumn: "clientId",
        };
        break;
      case "Status":
        obj = {
          ...obj,
          sortColumn: "status",
        };
        break;
      case "Source":
        obj = {
          ...obj,
          sortColumn: "sourcce",
        };
        break;
      default:
        return;
    }

    this.setState(obj, () => {
      this.dispatchPageAction(pageIndex);
    });
  }
  render() {
    const {
      segment_list_archive,
      segment_attributes,
      getAttributes,
      segment_summary,
      fetchSegmentDetail,
      clearSegmentSummary,
    } = this.props;
    return (
      <div className="segment-archive">
        <SegmentTable
          tableHeaderArray={this.state.tableHeadData}
          data={segment_list_archive}
          fetchSegmentDetail={fetchSegmentDetail}
          clearSegmentSummary={clearSegmentSummary}
          segment_summary={segment_summary}
          headerBeClick={(text, pageIndex) =>
            this.handleHeaderClick(text, pageIndex)
          }
          pageBeClick={page => this.handlePageClick(page)}
          nextBeClick={page => this.goNext(page)}
          previousBeClick={page => this.goPrevious(page)}
          nextGroupBeClick={page => this.nextGroup(page)}
          previousGroupBeClick={page => this.previousGroup(page)}
          selectRows={(page, row) => this.selectRows(page, row)}
          goToPage={page => this.goToPage(page)}
          sort={this.state.sortOrder}
          sortName={this.state.sortName}
          segment_attributes={segment_attributes}
          getAttributes={getAttributes}
          copySegmentRedirect={this.props.copySegment}
          copy_segment={this.props.copy_segment}
          segment_edit_creation={this.props.segment_edit_creation}
          selectedSegmentSetArray={this.props.selectedSegmentSetArray}
          flag="archive"
          selectedClientChanged={this.props.selectClient}
          handleIconClick={(targetText, targetIndex) =>
            this.handleIconClick(targetText, targetIndex)
          }
          reactiveSegment={this.props.reactiveSegment}
          reactive_success={this.props.reactive_success}
          reactive_on_progress={this.props.reactive_on_progress}
          history={this.props.history}
        />
        <div>
          {/*{*/}
          {/*(parseInt(selected_client) > 0) ? */}
          {/*<button type="button" disabled={this.props.roleId > 3 && client_info && client_info.subscription && client_info.subscription.id > 1 } className="btn btn-default legitRipple segments-create" onClick={(e)=>{this.handleCreateSegmentClick.bind(this)}}>*/}
          {/*<Link to="/segment/create">Create an Audience Segment </Link>*/}
          {/*</button> : <button disabled type="button" className="btn btn-default legitRipple segments-create">*/}
          {/*Create an Audience Segment*/}
          {/*</button>*/}
          {/*}*/}
        </div>
      </div>
    );
  }
}

export default Archive;



// WEBPACK FOOTER //
// ./src/components/Segment/List/Archive/Archive.jsx